import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { TemplateModule } from 'src/app/template/template.module';

import { ClassesSelectorComponent } from './components/classes-selector/classes-selector.component';
import { ClassSelectorComponent } from './components/class-selector/class-selector.component';

import { ClassService } from './services/class.service';

@NgModule({

    declarations: [
        ClassesSelectorComponent,
        ClassSelectorComponent
    ],

    imports: [
        CommonModule,
        SharedModule,
        TemplateModule
    ],

    exports: [
        ClassesSelectorComponent
    ],

    providers: [
        ClassService
    ]

})
export class ClassesModule { }
